(function(){
  // Fills the KBYG Urgency countdown chips from data-end (an ISO date with a
  // UTC offset), once a second. Leaves the
  // chips hidden if the date doesn't parse, and hides them once it passes.
  // Re-runs when the theme editor redraws a section.
  function init(root){
    var timers = root.querySelectorAll('[data-kby-countdown]');
    if(!timers.length) return;

    function pad(n){ return n < 10 ? '0' + n : String(n); }

    timers.forEach(function(el){
      var end = Date.parse(el.getAttribute('data-end'));
      if(isNaN(end)) return;

      var days = el.querySelector('[data-kby-countdown-days]');
      var hours = el.querySelector('[data-kby-countdown-hours]');
      var mins = el.querySelector('[data-kby-countdown-mins]');
      var secs = el.querySelector('[data-kby-countdown-secs]');
      var interval = null;

      function tick(){
        var left = end - Date.now();
        if(left <= 0){
          el.hidden = true;
          if(interval) clearInterval(interval);
          return;
        }
        var totalSecs = Math.floor(left / 1000);
        days.textContent = pad(Math.floor(totalSecs / 86400));
        hours.textContent = pad(Math.floor(totalSecs % 86400 / 3600));
        mins.textContent = pad(Math.floor(totalSecs % 3600 / 60));
        if(secs) secs.textContent = pad(totalSecs % 60);
        el.hidden = false;
      }

      tick();
      if(!el.hidden) interval = setInterval(tick, 1000);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

(function(){
  // Copies the discount code from a KBYG Urgency headline. Shows "Copied"
  // in place of the code for a moment and announces it to screen readers.
  var status = document.createElement('span');
  status.className = 'kby-visually-hidden';
  status.setAttribute('role', 'status');
  document.body.appendChild(status);

  function fallbackCopy(text){
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try{ document.execCommand('copy'); }catch(e){}
    document.body.removeChild(area);
  }

  function init(root){
    root.querySelectorAll('[data-kby-copy-code]').forEach(function(btn){
      var timer = null;
      btn.addEventListener('click', function(){
        var code = btn.getAttribute('data-kby-copy-code');
        var done = function(){
          btn.classList.add('is-copied');
          status.textContent = 'Code ' + code + ' copied';
          clearTimeout(timer);
          timer = setTimeout(function(){ btn.classList.remove('is-copied'); status.textContent = ''; }, 1600);
        };
        if(navigator.clipboard && window.isSecureContext){
          navigator.clipboard.writeText(code).then(done, function(){ fallbackCopy(code); done(); });
        }else{
          fallbackCopy(code); done();
        }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
